module.exports = ( ConcurrentResource, $q, endpoints, Login ) ->

  @User = ConcurrentResource("#{endpoints.User}", {}, {
    get: {
      method: 'GET',
      cache: true,
      interceptor:
        responseError: ( response ) ->
          if response.status == 403
            Login.redirectToLogin()
          $q.reject(response)
    }
  })

  return
